import React from 'react';
import { Box, Button, Paragraph } from '@zillow/constellation-10';

type Props = {
  title: string;
  onEdit: () => void;
  showEdit: boolean;
  editingDisabled: boolean;
  className: string;
  buttonTitle: string;
};

class DetailsCard extends React.Component<React.PropsWithChildren<Props>> {
  static defaultProps = {
    title: '',
    onEdit: () => {},
    showEdit: true,
    editingDisabled: false,
    className: '',
    buttonTitle: 'Edit',
  };

  gotoEditPage = (e): void => {
    const { onEdit } = this.props;
    e.preventDefault();
    onEdit();
  };

  render(): React.ReactNode {
    const { editingDisabled, children, showEdit, buttonTitle } = this.props;
    const contents = React.Children.map(
      children,
      (child, index) =>
        child && (
          <Box key={index.toString()} className="fs-exclude" css={{ lineHeight: '1.5rem', textStyle: 'body' }}>
            {child}
          </Box>
        ),
    );

    return (
      <Box css={{ marginTop: '24px' }}>
        <Box css={{ display: 'flex', alignItems: 'flex-start', gap: 'layout.default' }}>
          <Box css={{ flex: 1, minWidth: 0 }}>
            <Paragraph textStyle="body-bold">{this.props.title}</Paragraph>
            {contents}
          </Box>
          <Box css={{ flexShrink: 0 }}>
            {showEdit && (
              <Button
                emphasis="outlined"
                aria-label={`${buttonTitle} ${this.props.title.toLowerCase()}`}
                onClick={this.gotoEditPage}
                disabled={editingDisabled}
              >
                {buttonTitle}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    );
  }
}

export default DetailsCard;
